import { useQuery } from '@tanstack/react-query';
import { paiementsApi } from '../services/api';

/** La liste des valideurs (Paiements > Paramètres) ; le premier est le valideur par défaut. */
export function useValideursPaiements() {
  return useQuery({
    queryKey: ['paiements-valideurs'],
    queryFn: () => paiementsApi.valideurs(),
    staleTime: 60_000,
  });
}
